import { Clock, Users, DollarSign, Zap, CheckCircle, ArrowRight } from "lucide-react";

export default function SolutionSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-solution-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        THE SOLUTION
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-8 leading-tight">
        AppellatePro.AI generates the Record on Appeal in minutes
      </h1>

      <div className="flex-1 flex flex-col md:flex-row items-stretch md:items-center gap-4 sm:gap-6 min-h-0">
        <div className="flex-1 rounded-xl border border-slate-200 bg-slate-50 p-5 sm:p-6 flex flex-col">
          <div className="text-[10px] font-bold tracking-[0.15em] uppercase text-slate-400 mb-5 font-body">
            Before
          </div>
          <div className="space-y-4 flex-1 flex flex-col justify-center">
            <div className="flex items-center gap-3">
              <Clock className="h-4 w-4 text-red-400 shrink-0" />
              <span className="text-sm text-slate-700 font-body">
                Days and sometimes weeks of turnaround
              </span>
            </div>
            <div className="flex items-center gap-3">
              <Users className="h-4 w-4 text-red-400 shrink-0" />
              <span className="text-sm text-slate-700 font-body">
                Manual, labor-intensive process
              </span>
            </div>
            <div className="flex items-center gap-3">
              <DollarSign className="h-4 w-4 text-red-400 shrink-0" />
              <span className="text-sm text-slate-700 font-body">
                $5,000 &ndash; $20,000 per appeal
              </span>
            </div>
          </div>
        </div>

        <div className="shrink-0 flex flex-col items-center gap-1">
          <ArrowRight className="h-6 w-6 sm:h-7 sm:w-7 text-blue-600 rotate-90 md:rotate-0" />
        </div>

        <div className="flex-1 rounded-xl border border-blue-200 bg-blue-50 p-5 sm:p-6 flex flex-col">
          <div className="text-[10px] font-bold tracking-[0.15em] uppercase text-blue-600 mb-5 font-body">
            After
          </div>
          <div className="space-y-4 flex-1 flex flex-col justify-center">
            <div className="flex items-center gap-3">
              <Zap className="h-4 w-4 text-blue-600 shrink-0" />
              <span className="text-sm text-slate-700 font-body">
                15 &ndash; 30 minute turnaround
              </span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle className="h-4 w-4 text-blue-600 shrink-0" />
              <span className="text-sm text-slate-700 font-body">
                Fully automated workflow
              </span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle className="h-4 w-4 text-blue-600 shrink-0" />
              <span className="text-sm text-slate-700 font-body">
                Scalable, software-first pricing
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 md:gap-6 mt-4 md:mt-5 justify-center">
        {[
          "Court-ready, formatted output",
          "Eliminates repetitive work",
          "Speed, consistency & control",
        ].map((text, i) => (
          <span key={i} className="text-sm text-slate-400 font-body">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
